import { MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";

export const Locations = () => {
  const { t } = useLang();
  return (
    <section id="locations" className="py-20 md:py-28 bg-surface" data-testid="locations-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={t.locations.label} title={t.locations.title} center />
        <div className="grid md:grid-cols-3 gap-6">
          {t.locations.items.map((loc, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="card p-8 h-full hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.18)]" data-testid={`location-${i}`}>
                <div className="flex items-center gap-2 flex-wrap">
                  {loc.badge && <span className="pill bg-tricolor-green text-white">{loc.badge}</span>}
                  {loc.tag && <span className="pill bg-ink/5 text-ink/60">{loc.tag}</span>}
                </div>
                <h3 className="mt-5 font-display font-extrabold text-3xl text-ink tracking-tight">{loc.city}</h3>
                <p className="mt-3 flex items-start gap-2 text-muted">
                  <MapPin size={18} className="text-tricolor-green mt-0.5 flex-shrink-0" />
                  {loc.addr}
                </p>
                <p className="mt-4 pt-4 border-t border-line text-sm font-medium text-ink/70">{loc.mode}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
